<template>
  <div class="columns">

    <div class="column">
      <sc-field label="Ocorrências">
        <sc-reports-occurrences-dropdown
          v-model="filters.occurrence" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field
        label="Transportadora"
        :type="!isValidLogisticProvider ? 'is-danger' : ''"
        :message="!isValidLogisticProvider ? 'Escolha uma transportadora' : ''">
        <sc-logistic-provider-dropdown
          v-model="filters.logistic_provider_id"
          :active="false"/>
      </sc-field>
    </div>

    <div class="column">

      <sc-field
        label="Métodos de entrega">
        <sc-delivery-method-dropdown
          v-model="filters.delivery_method_id"
          :logistic-provider-id="filters.logistic_provider_id"
          :option-all="true"
          :active="false" />
      </sc-field>
    </div>

    <div class="column">
      <sc-field label="Tipo de período">
        <sc-select
          v-model="filters.date_type"
          placeholder="Selecione"
          expanded>
          <option
            v-for="period in periodsList"
            :key="period.value"
            :value="period.value">
            {{ period.label }}
          </option>
        </sc-select>
      </sc-field>
    </div>

    <div class="column">
      <sc-field label="Período">
        <sc-range-date-picker
          v-model="filters.dateRange"
          :max-date="maxDate"
          :format="formatDateRange"
          :minDate="endLimit"
          class="is-small"/>
      </sc-field>
    </div>

  </div>
</template>

<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import {
    ScField,
    ScSelect,
    ScRangeDatePicker,
    ScState,
    ScLogisticProviderDropdown,
    ScDeliveryMethodDropdown,
  } from '@intelipost-js/secure-components';
  import ScReportsOccurrencesDropdown from '../../../../components/sc-reports-occurrences-dropdown/ScReportsOccurrencesDropdown';
  import Constants from '../../../../../config';

  export default {
    name: 'sc-report-filters',
    props: {
      filters: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        endLimit: Moment().subtract(Constants.reports_range_days, 'days').toDate(),
        maxDate: Moment().toDate(),
        periodsList: [
          {
            label: 'Data de criação',
            value: 'CREATED_DATE',
          },
          {
            label: 'Data prevista',
            value: 'ESTIMATED_DATE',
          },
          {
            label: 'Data prevista entrega transportadora',
            value: 'ESTIMATED_LP_DATE',
          },
          {
            label: 'Data de entrega',
            value: 'DELIVERED_DATE',
          },
        ],
      };
    },
    computed: {
      isValidLogisticProvider() {
        return this.filters && this.filters.logistic_provider_id;
      },
    },
    methods: {
      formatDateRange(dateRange) {
        return {
          start: Moment(dateRange.start).format('YYYY-MM-DD'),
          end: Moment(dateRange.end).format('YYYY-MM-DD'),
        };
      },
    },
    components: {
      ScField,
      ScSelect,
      ScRangeDatePicker,
      ScState,
      ScLogisticProviderDropdown,
      ScDeliveryMethodDropdown,
      ScReportsOccurrencesDropdown,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/components/sc-report-provider-filters/ScReportProviderFilters.vue?3ae72348